import { CheckoutDeliveryAddressEvent, CheckoutEvent } from '@spartacus/checkout/base/root'
import { Address } from '@spartacus/core'

export abstract class CheckoutQuoteInfoEvent extends CheckoutEvent {}

export class CheckoutQuoteInfoSetEvent extends CheckoutQuoteInfoEvent {

  static readonly type = 'CheckoutQuoteInfoSetEvent'

  isSuccessful?: boolean

  error?: any
}

export abstract class CheckoutContactDetailsEvent extends CheckoutEvent {}

export class CheckoutContactDetailsSetEvent extends CheckoutContactDetailsEvent {

  static readonly type = 'CheckoutContactDetailsSetEvent'

  isSuccessful?: boolean

  error?: any
}

export class CheckoutDeliveryAddressSetFailEvent extends CheckoutDeliveryAddressEvent {

  static readonly type = 'CheckoutDeliveryAddressSetFailEvent'

  error?: any
}

export abstract class CheckoutBillingAddressEvent extends CheckoutEvent {}

export class CheckoutBillingAddressSetEvent extends CheckoutBillingAddressEvent {

  static readonly type = 'CheckoutBillingAddressSetEvent'

  address?: Address

  isSuccessful?: boolean

  error?: any
}

export class CheckoutRedirectToPaymentEvent extends CheckoutEvent {

  static readonly type = 'CheckoutRedirectToPaymentEvent'

  isSuccessful?: boolean

  error?: any
}

export abstract class CheckoutPlaceOrderWithPaymentEvent extends CheckoutEvent {}

export class CheckoutPlaceOrderWithPaymentSuccessEvent extends CheckoutEvent {

  static readonly type = 'CheckoutPlaceOrderWithPaymentSuccessEvent'

  isSuccessful?: boolean
}

export class CheckoutPlaceOrderWithPaymentFailEvent extends CheckoutPlaceOrderWithPaymentEvent {

  static readonly type = 'CheckoutPlaceOrderWithPaymentFailEvent'

  returnStatus?: string

  error?: any
}

export class CheckoutResetIngenicoPaymentEvent extends CheckoutEvent {

  static readonly type = 'CheckoutResetIngenicoPaymentEvent'

  isSuccessful?: boolean

  error?: any
}
